<template>
  <div
    v-if="validTabs.length > 1"
    class="tabs tabs--bleed extra-spacing"
  >
    <router-link
      v-for="tab in validTabs"
      :key="tab.label"
      class="tabs__tab"
      :class="{
        'tabs__tab--active': $route.name === tab.route.name
      }"
      :to="tab.route"
    >
      <span
        v-if="tab.icon"
        class="icon far"
        :class="tab.icon"
      />
      {{ tab.label }}
    </router-link>
  </div>
</template>



<script>
  export default {
    name: 'TabbedRoutes',

    props: {
      invalidRedirectRoute: {
        type: Object,
        default: null
      },
      tabs: {
        type: Array,
        required: true
      }
    },

    computed: {
      validTabs() {
        return this.tabs.filter(tab => ('isValid' in tab ? tab.isValid : true));
      }
    },

    watch: {
      $route: 'redirect'
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        this.redirect();
      },

      redirect() {
        const activeTab = this.validTabs.find(tab => tab.route.name === this.$route.name);

        if (activeTab) {
          return;
        }

        const tabToRedirect = this.validTabs[0];

        if (tabToRedirect) {
          this.$router.replace(tabToRedirect.route);
        }

        else if (this.invalidRedirectRoute) {
          this.$router.replace(this.invalidRedirectRoute);
        }
      }
    }
  };
</script>
